import { EReminderStage } from '../enums/payment-reminder.enum';
import { EFurnished, EPaymentAdvice, EResaleNoOfRoom, EResaleNoOfRoomHdb, EResalePropertyType, EResalePropertyTypeSearch, EResaleType, EResaleDocumentType } from '../enums/resale.enum';
import { OptionDescription } from './option.type';

export type ResaleDateKey = 'submissionDate' | 'agreementDate' | 'commencementDate' | 'optionDate' | 'expireDate' | 'completionDate' | 'billingDate' | 'exerciseDate';

export type ResaleTypeDescription = {
  id: EResaleType;
  value: EResaleType;
  viewValue: string;
  correspondingField: ResaleDateKey[];
  mandatoryField: ResaleDateKey[];
};

export type ResaleTypeOptionRecord = Record<EResaleType, ResaleTypeDescription>;

export type ResalePropertyTypeRecord = Record<EResalePropertyType, OptionDescription<EResalePropertyType>>;

export type ResalePropertyTypeSearchRecord = Record<EResalePropertyTypeSearch, OptionDescription<EResalePropertyTypeSearch>>;

export type FurnishedRecord = Record<EFurnished, OptionDescription<EFurnished>>;

export type PaymentAdviceRecord = Record<EPaymentAdvice, OptionDescription<EPaymentAdvice>>;

export type ResaleNoOfRoomTypeRecord = Record<EResaleNoOfRoom, OptionDescription<EResaleNoOfRoom>>;

export type ResaleNoOfRoomTypeHdbRecord = Record<EResaleNoOfRoomHdb, OptionDescription<EResaleNoOfRoomHdb>>;

export type DocumentTypeRecord = Record<EResaleDocumentType, OptionDescription<EResaleDocumentType>>;

export type StageRecord = Record<EReminderStage, OptionDescription<EReminderStage>>;
